import React, { Component } from 'react';
import { Routes as routes } from '../../navigation';
import { isMobileOnly } from "react-device-detect";

import { NavigationActions } from '../../actions';
import { NotificationsUtils } from '../../utils';
import { Line } from '../../components';
import '../../css/common/NavBar.css';

class NavBar extends Component {

  renderNavBarButton = (title, route, badgeCount) => {
    let selected      = this.props.currentRoute === route;
    let buttonTitle   = title.toLowerCase();
    buttonTitle       = buttonTitle ? buttonTitle.charAt(0).toUpperCase() + buttonTitle.slice(1) : buttonTitle;
    let display_badge = badgeCount && badgeCount > 0 ? true : false;

    return <div className="flex-container flex-container-column nav-bar-button"  style={{  }} onClick={ selected ? () => { } : () => { NavigationActions.navigateTo(route) }}>
      <div></div>
      <div className={`nav-bar-button-title flex-container-row ${ selected ? 'nav-bar-button-selected' : '' }`} style={{ alignItems: 'center' }}>
       <span>{ buttonTitle }</span>
       { display_badge ? <span style={{ height: 6, width: 6, borderRadius: 3, backgroundColor: '#F71735', marginLeft: 10 }}></span> : null }
      </div>
      <Line style={{ height: 2, backgroundColor: selected ? '#1dc2ff' : 'white' }}/>
    </div>

  }

  renderLeftSectionButtons = (practice, role, notifDict, notifIdDict) => {
    let practice_details    = this.props.practice;
    let is_instant_practice = practice_details && practice_details.subscription && (practice_details.subscription.subscription_type === 'INSTANT' || practice_details.subscription.subscription_type === 'INSTANT_PAID');

    if (!practice || !role) {
      return <div className="flex-container flex-container-row">
        { this.renderNavBarButton('HOME', routes.HOME, NotificationsUtils.getBadgeCountForNavItem('HOME', '', notifDict)) }
      </div>
    }

    if (role === 'vet' || role === 'behaviorist') {
      return <div className="flex-container flex-container-row">
          { is_instant_practice ? this.renderNavBarButton('INSTANT', routes.INSTANT_HOME, 0)
                                : this.renderNavBarButton('HOME', routes.HOME, NotificationsUtils.getBadgeCountForNavItem('HOME', practice, notifDict)) }
          { this.renderNavBarButton('CONSULTATIONS', routes.CONSULTATIONS, NotificationsUtils.getBadgeCountForNavItem('CONSULTATIONS', practice, notifDict)) }
          { this.renderNavBarButton('CLIENTS', routes.CLIENTS, NotificationsUtils.getBadgeCountForNavItem('CLIENTS', practice, notifDict)) }
          { !is_instant_practice ? this.renderNavBarButton('INSTANT', routes.INSTANT_HOME, 0) : null }
        </div>
    }

    if (role === 'tech') {
      return <div className="flex-container flex-container-row">
          { is_instant_practice ? this.renderNavBarButton('INSTANT', routes.INSTANT_HOME, 0)
                                : this.renderNavBarButton('HOME', routes.HOME, NotificationsUtils.getBadgeCountForNavItem('HOME', practice, notifDict)) }
          { this.renderNavBarButton('CONSULTATIONS', routes.CONSULTATIONS, NotificationsUtils.getBadgeCountForNavItem('CONSULTATIONS', practice, notifDict)) }
          { this.renderNavBarButton('CLIENTS', routes.CLIENTS, NotificationsUtils.getBadgeCountForNavItem('CLIENTS', practice, notifDict)) }
          { !is_instant_practice ? this.renderNavBarButton('INSTANT', routes.INSTANT_HOME, 0) : null }
        </div>
    }

    if (role === 'admin' || role === 'practice_manager' || role === 'practice_owner') {
      return <div className="flex-container flex-container-row">
          { is_instant_practice ? this.renderNavBarButton('INSTANT', routes.INSTANT_HOME, 0)
                                : this.renderNavBarButton('HOME', routes.HOME, NotificationsUtils.getBadgeCountForNavItem('HOME', practice, notifDict)) }
          { this.renderNavBarButton('CONSULTATIONS', routes.CONSULTATIONS, NotificationsUtils.getBadgeCountForNavItem('CONSULTATIONS', practice, notifDict)) }
          { this.renderNavBarButton('PRACTICE', routes.PRACTICE, NotificationsUtils.getBadgeCountForNavItem('PRACTICE', practice, notifDict)) }
          { this.renderNavBarButton('STAFF', routes.STAFF, NotificationsUtils.getBadgeCountForNavItem('STAFF', practice, notifDict)) }
          { this.renderNavBarButton('CLIENTS', routes.CLIENTS, NotificationsUtils.getBadgeCountForNavItem('CLIENTS', practice, notifDict)) }
          { !is_instant_practice ? this.renderNavBarButton('INSTANT', routes.INSTANT_HOME, 0) : null }
        </div>
    }
  }

  renderRightSectionButtons = (practice, role, notifDict, notifIdDict) => {

    return <div className="flex-container flex-container-row" style={{ marginRight: 10 }}>
      { this.renderNavBarButton('MY ACCOUNT', routes.MY_ACCOUNT, NotificationsUtils.getBadgeCountForNavItem('MY ACCOUNT', practice, notifDict, notifIdDict)) }
      { this.renderNavBarButton('SETTINGS', routes.SETTINGS, NotificationsUtils.getBadgeCountForNavItem('SETTINGS', practice, notifDict)) }
    </div>
  }

  renderNavBar = (practice, role) => {

    const notificationsTypeDict = this.props.notifications && this.props.notifications.notificationsTypeDict ? this.props.notifications.notificationsTypeDict : {};
    const notificationsIdDict = this.props.notifications && this.props.notifications.notificationsDict ? this.props.notifications.notificationsDict : {};

    if (role && role === 'front_desk') {
      return <div className="nav-bar-container flex-container flex-container-row">
        { this.renderNavBarButton('TASKS', routes.FRONT_DESK_HOME, 0) }
        { this.renderNavBarButton('CONSULTATIONS', routes.FRONT_DESK_CONSULTATIONS, 0) }
        { this.renderNavBarButton('CLIENTS', routes.CLIENTS, NotificationsUtils.getBadgeCountForNavItem('CLIENTS', practice, notificationsTypeDict)) }
      </div>
    }

    return (
      <div className="nav-bar-container flex-container flex-container-row flex-space-between">
        { this.renderLeftSectionButtons(practice, role, notificationsTypeDict, notificationsIdDict) }
        { this.renderRightSectionButtons(practice, role, notificationsTypeDict, notificationsIdDict) }
      </div>
    );
  }

  renderInstantNavBar = () => {
    return <div className="nav-bar-container flex-container flex-container-row flex-space-between">
     <div className="flex-container flex-container-row">
        { this.renderNavBarButton('DASHBOARD', routes.INSTANT_HOME, 0) }
        { this.renderNavBarButton('COMPLETED', routes.INSTANT_COMPLETED, 0) }
      </div>
     <div className="flex-container flex-container-row">
        { this.renderNavBarButton('HELP', routes.INSTANT_HELP, 0) }
        { this.renderNavBarButton('SETTINGS', routes.INSTANT_SETTINGS, 0) }
      </div>
    </div>
  }

  render() {
    let hide_nav_bar = isMobileOnly;

    if (hide_nav_bar) {
      return null;
    }
    return this.renderNavBar(this.props.selectedPractice, this.props.selectedRole)
  }

}

export default NavBar
